export const LOGIN_USER = "LOGIN_USER";
export const INVALID_LOGIN_USER = "INVALID_LOGIN_USER";
export const ERROR_LOGIN_USER = "INVALID_LOGIN_USER";
export const LOGOUT = "LOGOUT";
export const REFRESH_TOKEN_TIME = "REFRESH_TOKEN_TIME";
export const UPDATE_SECURITY_QUESTION_TAG = "UPDATE_SECURITY_QUESTION_TAG";
export const RESET = "RESET";
